import type { QuestionAnswers } from '../../types/session';

/** Gesamt-Score = Summe aller Antwortpunkte (Abschnitt 15.1). Reine Funktion (TS-005). */
export function calculateOverallScore(answers: QuestionAnswers): number {
  return Object.values(answers).reduce((total, answer) => {
    if (!answer) return total;
    return total + answer.score;
  }, 0);
}

export function calculateOverallPercentage(score: number, maximum: number): number {
  return Math.round((score / maximum) * 100);
}
